import Vue from 'vue'
import VueRouter from 'vue-router'
import home from '../views/home/home.vue'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.replace = function replace(location) {
	return originalPush.call(this, location).catch(err => err)
}

const points = () => import('../views/points/points.vue'); //关于本会

const dynamic = () => import('../views/dynamic/dynamic.vue'); //新闻动态
const dynamic_content = () => import('../views/dynamic/dynamic_content.vue'); //新闻动态
const inform = () => import('../views/dynamic/inform.vue'); //通知公告
const own_dynamic = () => import('../views/dynamic/own_dynamic.vue'); //本会动态
const trade_dynamic = () => import('../views/dynamic/trade_dynamic.vue'); //行业动态
const video_news = () => import('../views/dynamic/video_news.vue'); //视频新闻

const copyright = () => import('../views/copyright/copyright.vue'); //著作权登记
const copyrightDetail = () => import('../views/copyright/detail.vue'); //著作权登记详情

const member_center = () => import('../views/member_center/member_center.vue'); //会员中心
const league = () => import('../views/member_center/league.vue'); //联合会入会须知
const committee = () => import('../views/member_center/committee.vue'); //专业委员会入会须知
const business = () => import('../views/member_center/business.vue'); //会员企业名录
const mien = () => import('../views/member_center/mien.vue'); //会员风采
const meberDetail = () => import('../views/member_center/detail.vue'); //详情页

const legal = () => import('../views/legal/legal.vue'); //法律事务
const classic_case = () => import('../views/legal/classic_case.vue'); //经典案例
const mediation = () => import('../views/legal/mediation.vue'); //版权调解
const detail = () => import('../views/legal/detail.vue'); //详情页

const file_download = () => import('../views/file_download/file_download.vue'); //文件下载

const policies = () => import('../views/policies/policies.vue'); //法律法规
const lawRegulation = () => import('../views/policies/law_regulation.vue'); //法律
const regulation = () => import('../views/policies/regulations.vue'); //行政法规
const departmentalRegulation = () => import('../views/policies/departmental_regulation.vue'); //部门规章
const interpretation = () => import('../views/policies/interpretation.vue'); //司法解释
const internationalTreaty = () => import('../views/policies/international_treaty.vue'); //国际条约
const policiesDetail = () => import('../views/policies/detail.vue'); //政策法规详情

const mahatma = () => import('../views/mahatma/mahatma.vue'); //维权大圣

const demo = () => import('../views/demo/demo.vue'); //视频新闻

const routes = [{
		path: '/',
		name: 'home',
		component: home
	},
	{
		path: '/points',
		name: "points",
		component: points
	},
	{
		path: '/dynamic',
		name: "dynamic",
		component: dynamic,
		children: [
			{
				path:'/',
				component: dynamic
			},
			{
				path:'inform',
				component: inform
			},
			{
				path:'own_dynamic',
				component: own_dynamic
			},
			{
				path:'trade_dynamic',
				component: trade_dynamic
			},
			{
				path:'video_news',
				component: video_news
			},
			{
				path:'dynamic_content',
				component: dynamic_content
			},
		]
		
	},

	{
		path: '/copyright',
		name: "copyright",
		component: copyright,
		children: [{
				path: 'detail',
				name: 'detail',
				component: copyrightDetail
			},
		]
	},
	{
		path: '/member',
		component: member_center,
		children: [
			{
				path: 'league',
				component: league
			},
			{
				path: 'committee',
				component: committee
			},
			{
				path: 'business',
				component: business
			},
			{
				path: 'mien',
				component: mien
			},
			{
				path: 'meberDetail',
				component: meberDetail
			},
		]
	},
	{
		path: '/legal',
		name: 'legal',
		component: legal,
		children: [{
				path: '/',
				component: classic_case
			},
			{
				path: 'mediation',
				component: mediation
			},
			{
				path: 'detail',
				component: detail
			},
		]
	},
	{
		path: '/file_download',
		name: "file_download",
		component: file_download,
	},
	{
		path: '/policies',
		name: "policies",
		component: policies,
		children: [
			{
				path: 'detail',
				name: 'detail',
				component: policiesDetail,
			},
			{
				path: 'lawRegulation',
				component: lawRegulation,
			},
			{
				path: 'regulation',
				component: regulation,
			},
			{
				path: 'departmentalRegulation',
				component: departmentalRegulation,
			},
			{
				path: 'internationalTreaty',
				component: internationalTreaty,
			},
			{
				path: 'interpretation',
				component: interpretation,
			},
		]
	},
	{
		path: '/mahatma',
		name: "mahatma",
		component: mahatma,
	},
	{
		path:'/demo',
		name: "name",
		component: demo
	},

]

const router = new VueRouter({
	mode: 'history',
	routes,
	scrollBehavior(to, from, savedPosition) {
		return {
			x: 0,
			y: 0
		}
	}
})

export default router